import { createFileRoute, redirect } from "@tanstack/react-router";

// Tastings moved out from under their project once they could hold several
// products; old links (bookmarks, emails) land on the tasting itself.
export const Route = createFileRoute("/food-app/projects/$project_id/sensory/$sensory_session_id")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/food-app/tastings/$tasting_id",
      params: { tasting_id: parseInt(params.sensory_session_id, 10) },
    });
  },
});
